import CardRankings from "../../../../src/components/card-rankings/CardRankings";
import dmcRatings from "../../../../src/data/articles/cube-prospective-dominaria-united-commander/dmc-prospective-ratings.json";
import ProspectiveIntro from "../../../../src/components/article-elements/ProspectiveIntro.tsx";
import * as React from 'react';
export default {
  CardRankings,
  dmcRatings,
  ProspectiveIntro,
  React
};